import Chart from 'react-apexcharts';
import React, { Component, Fragment } from 'react';
import { Grid, Tooltip, Card, CardContent } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import exportOptions from '../chartExportOptions';
import AuditTable from '../Insights/auditTable';
import meetingAPI from '../../../flowtrace-api/meetingAPI';

const info = <HelpOutline style={{ fontSize: 15 }}/>;

const chartOptions = {
  chart: { animations: { enabled: false }, ...exportOptions("Time", "Count") },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '12px',
    },
    formatter: function(text, op) {
      return [text];
    },
    offsetY: 0.5,
    offsetX: -0.5
  },
  plotOptions: {
    heatmap: {
      //distributed: true,
      shadeIntensity: 0.1,
      inverse: true
    }
  },
  tooltip: {
    y: {
      formatter: function(value) {
        if(value<1) return "";
        return Math.abs(value) + " ";
      },
      title:{
        formatter: function() {return "Meetings:"}
      }
    },
    z: {
      formatter: function([invites, internal, external]) {
        const total = invites;
        const int = (Math.abs(internal/total) * 100).toFixed(0);
        const ext = (Math.abs(external/total) * 100).toFixed(0);

        const totalString = ` (out of ${total} total invites)`
        if(total<1)
          return "";
        if(internal<1)
          return ext + "% external " + totalString;
        if(external<1)
          return int + "% internal " + totalString;
        return int + "% internal, " + ext + "% external " + totalString;
      },
      title: "Invite Types:"
    }
  },
};

class MeetingStatisticsTable extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, dialogOpen:false, dialogContent:[] };
  }



  async componentDidMount() {
    const day = [];
    for(let i = 0 ; i <24 ; i++)
      day.push({id:i, x: (i<10?"0"+i:i) +":00", y:0, w:0, z:[0,0,0]});// y=meetings, z[0]=invites, z[1]=internal, z[2]=external

    const series = [
      { id:0, name: "Monday", data:JSON.parse(JSON.stringify(day))},
      { id:1, name: "Tuesday", data:JSON.parse(JSON.stringify(day))},
      { id:2, name: "Wednesday", data:JSON.parse(JSON.stringify(day))},
      { id:3, name: "Thursday", data:JSON.parse(JSON.stringify(day))},
      { id:4, name: "Friday", data:JSON.parse(JSON.stringify(day))},
      { id:5, name: "Saturday", data:JSON.parse(JSON.stringify(day))},
      { id:6, name: "Sunday", data:JSON.parse(JSON.stringify(day))},
    ];

    const total = [
      {id:"total", x:"Total", y:0, w:0, z:[0,0, 0]}, // y=meetings, z[0]=invites, z[1]=internal, z[2]=external
      ];
    const totalSeries = [
      { id:0, name: "Monday", data:JSON.parse(JSON.stringify(total))},
      { id:1, name: "Tuesday", data:JSON.parse(JSON.stringify(total))},
      { id:2, name: "Wednesday", data:JSON.parse(JSON.stringify(total))},
      { id:3, name: "Thursday", data:JSON.parse(JSON.stringify(total))},
      { id:4, name: "Friday", data:JSON.parse(JSON.stringify(total))},
      { id:5, name: "Saturday", data:JSON.parse(JSON.stringify(total))},
      { id:6, name: "Sunday", data:JSON.parse(JSON.stringify(total))},
    ];


    this.props.heatmap.forEach((day, index) => {
      totalSeries[index].data[0].y = day.meetings;
      totalSeries[index].data[0].z[0] = day.invites;
      totalSeries[index].data[0].z[1] = day.internal_invites;
      totalSeries[index].data[0].z[2] = day.external_invites;
      day.hour.forEach((hour, hourIndex) => {
        series[index].data[hourIndex].y = hour.meetings;
        series[index].data[hourIndex].z[0] = hour.invites;
        series[index].data[hourIndex].z[1] = hour.internal_invites;
        series[index].data[hourIndex].z[2] = hour.external_invites;
      })
    });
    this.setState({ loading: false, heatmap:series, totalHeatmap:totalSeries });
  }


  closeDialog() {
    this.setState({dialogOpen:false});
  }
  async openDialog(event, context, config) {
    const hourlyHeatmap = config.w.config.series[config.seriesIndex].data.length > 1 ? true : false;
    const hour = config.dataPointIndex;
    const weekday = config.seriesIndex + 1;
    const day = config.w.config.series[config.seriesIndex].name;
    const timeSlot = day + " " + (hour>9?hour:"0" + hour) + ":00";
    const dialogHeader = `Meetings @ ${timeSlot} (date and time based on ${Intl.DateTimeFormat().resolvedOptions().timeZone} timezone)`;
    this.setState({dialogOpen:true, dialogHeader, dialogLoading: true, dialogTimeSlot:timeSlot});
    const dataFilters = {...this.props.queryFilters};

    if(hourlyHeatmap){
      dataFilters.range_hour_start = hour;
      dataFilters.range_hour_end = hour;
    }
    dataFilters.weekdayFilter = [weekday];
    const auditData = await meetingAPI.audit(dataFilters, this.props.flowtraceUser)

    this.setState({dialogLoading: false, ...auditData});
  }

  render() {

    if (this.state.loading)
      return <div/>;

    const chartConfig = {
      ...chartOptions,
      chart:{...chartOptions.chart, 
        events: {
          dataPointSelection: this.openDialog.bind(this),       
          dataPointMouseEnter: function(event, _chartContext, opts) { 
            const dataPoint = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
            if(dataPoint && dataPoint.y)
              event.target.style.cursor = "pointer"; 
          } 
        }
      }
    };

    return (
      <Fragment >
        <Card className="card-box mb-4">
          <CardContent style={{width:"100%"}}>
            <div className=" font-weight-bold font-size-xl text-uppercase" >When We Meet</div>
            <div className="font-weight-bold mr-3 mb-3"> All times in your local timezone: {Intl.DateTimeFormat().resolvedOptions().timeZone}</div>
            <Grid container spacing={4}>
              <Grid item xs={12} md={12}>
                <Grid container spacing={4}>
                  <Grid item xs={4} md={2}>
                    <div className="d-flex align-items-start">
                      <Tooltip title="Here you can see the meeting load at the given day across the calendars. These are total number of meeting events starting during the given weekday. ">
                        <div className="font-weight-bold mr-3"> Meeting Events by Weekday  {info}</div>
                      </Tooltip>
                    </div>
                    <Chart key="totalHeatmap" options={chartConfig} series={this.state.totalHeatmap} type="heatmap" height="280"/>
                  </Grid>
                  <Grid item xs={8} md={10}>
                    <div className="d-flex align-items-start">
                      <Tooltip title="Here you can see the meeting load at the given hour across the calendars. Every hour slot is a weighted based on number of meetings starting at the given time for your timezone. You can click the heatmap for details about the meetings at the given time.">
                        <div className="font-weight-bold mr-3"> Internal and External Meeting Events by the Time and Weekday {info}</div>
                      </Tooltip>
                    </div>
                    <Chart key="timeheatmap" options={chartConfig} series={this.state.heatmap} type="heatmap" height="280"/>
                  </Grid>
              </Grid>
              </Grid>
            </Grid>
          </CardContent>
         </Card>
        <Dialog scroll={"paper"} fullWidth={true} maxWidth="xl" open={this.state.dialogOpen} onClose={this.closeDialog.bind(this)} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Meetings @ {this.state.dialogTimeSlot} (date and time based on {Intl.DateTimeFormat().resolvedOptions().timeZone} timezone)</DialogTitle>
          <DialogContent>
            <AuditTable flowtraceUser={this.props.flowtraceUser} queryFilters={this.props.queryFilters} members={this.state.members} meetings={this.state.meetings} loading={this.state.dialogLoading} title={" "}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog.bind(this)} color="primary"> Close </Button>
          </DialogActions>
        </Dialog>

        </Fragment>
    ); // end of return

  } // end of render()

} // end of class

export default MeetingStatisticsTable
